<template>
  <component
    :is="tag"
    v-fluent="{ size, color, enabled, effectSize }"
    :class="$style['fluent-component']"
  >
    <slot />
  </component>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { fluentDirective } from './fluentDirective';

export default defineComponent({
  name: 'FluentBorder',
  directives: {
    fluent: fluentDirective,
  },
  props: {
    color: {
      type: String,
      required: false,
      default: undefined,
    },
    size: {
      type: Number,
      required: false,
      default: 150,
    },
    enabled: {
      type: Boolean,
      required: false,
      default: true,
    },
    tag: {
      type: String,
      required: false,
      default: 'div',
    },
    effectSize: {
      type: Number,
      required: false,
      default: 2,
    },
  },
});
</script>

<style lang="postcss" module>
.fluent-component {
  border-radius: inherit;
  width: inherit;
  height: inherit;
}
</style>
